import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import '../styles/main.css';

export default function Banner({ businessName, salePointName }) {
    const [bannerImage, setBannerImage] = useState(null);
    const [showFallback, setShowFallback] = useState(true);
    const navigate = useNavigate();


    useEffect(() => {
    if (!businessName || !salePointName) {
        console.warn('Missing businessName or salePointName:', businessName, salePointName);
        return;
    }

    let isMounted = true;

    const fetchBanner = async () => {
        try {
            const res = await fetch(`/api/salePointConfig/${businessName}/${salePointName}`);

            // Don't navigate if component is unmounted or if we're already on the not-found page
            if (res.status === 404 && isMounted && window.location.pathname !== '/not-found') {
                console.log('Sale point not found, navigating to not-found page');
                navigate('/not-found', { replace: true }); 
                return;
            }

            if (!res.ok) throw new Error('Failed to fetch config');

            const config = await res.json();

            if (config.salePointBannerUrl && isMounted) {
                setBannerImage(config.salePointBannerUrl);
                setShowFallback(false);
            } else {
                throw new Error('No banner URL in config');
            }
        } catch (err) {
            console.warn('Banner fetch error:', err.message);
            if (isMounted) {
                setShowFallback(true);
            }
        }
    };

    fetchBanner();

    // Cleanup function to prevent state updates after unmount
    return () => {
        isMounted = false;
    };
}, [businessName, salePointName, navigate]);


    return (
        <div className="banner-wrapper">
            <div className="animated-banner">
                <AnimatePresence mode="wait">
                    {bannerImage && !showFallback && (
                        <motion.img
                            key={bannerImage}
                            src={bannerImage}
                            alt="SalePoint Banner"
                            className="banner-image"
                            initial={{ opacity: 1, scale: 1.05 }}
                            animate={{ opacity: 1, scale: 1 }}
                            exit={{ opacity: 0.2, scale: 1.05 }}
                            transition={{ duration: 1 }}
                            onError={(e) => {
                                e.target.onerror = null;
                                setShowFallback(true);
                            }}
                        />
                    )}
                </AnimatePresence>
            </div>
        </div>
    );
}
